import React from 'react';

function ArchivePage() {
  return (
    <div style={{ padding: '40px 20px', maxWidth: '1200px', margin: '0 auto' }}>
      <h1 style={{ 
        fontSize: '1.8rem', 
        marginBottom: '20px', 
        fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, sans-serif',
        textTransform: 'uppercase'
      }}>
        Event Archive
      </h1>
      <p style={{ 
        fontSize: '0.9rem', 
        lineHeight: '1.6', 
        color: '#666',
        fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, sans-serif' 
      }}>
        Browse through our past events, performances, and memorable moments at Idea Farm. 
        Relive the experiences and see what we've accomplished together.
      </p>
    </div>
  );
}

export default ArchivePage;
